// extracted by mini-css-extract-plugin
export default {"activity":"MainActivity_activity_Po4Zb"};